import React from 'react'
import { useState } from "react";

import preview from "../assets/game-screenshot-blur.png";

const GameDemo = () => {
    const [loaded, setLoaded] = useState(false);

    return (
        <section className='game_container'>
            <div className='game_info_container fadeOnScroll'>
                <h1 data-translate="gamedemo_h">TRY A DEMO 🚀</h1>
                <p data-translate="gamedemo_p">Try a quick demo and get a feel for what a custom-made promotional game could be.</p>
            </div>

            {
                !loaded ? (
                    <div
                        style={{
                            width: "100%",
                            maxWidth: "360px",
                            aspectRatio: "9 / 16",
                            // backgroundColor: "#120f34",
                            backgroundImage: `url(${preview})`,
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",

                            // color: "white",
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "20px",
                        }}
                    >

                        <button
                            onClick={() => setLoaded(true)}
                            className='contactUsButton'

                            style={{
                                backgroundColor: "white",
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                fontSize: "20px"
                            }}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = "#141033")}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = "white")}
                        >
                            ▶ Load Game
                        </button>
                    </div>
                ) : (
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "360px",
                            aspectRatio: "9 / 16",
                            borderRadius: "10px",
                            overflow: "hidden",
                        }}>
                        <iframe
                            src="/gamedemo/index.html"
                            // width="360px"
                            // height="640px"
                            allowFullScreen
                            width="100%"
                            height="100%"
                            title="My Game">
                        </iframe>
                        <button
                            onClick={() => setLoaded(false)}
                            className='contactUsButton'
                            style={{
                                position: "absolute",
                                top: "8px",
                                right: "8px",

                                backgroundColor: "white",
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                fontSize: "15px",
                                width:"80px",
                                
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                padding: "6px 10px",
                                zIndex: 10,
                                transition: "0.2s ease-in-out",
                            }}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = "#141033")}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = "white")}
                        >
                            ✕ Exit
                        </button>
                    </div>
                )}



        </section>
    )
}

export default GameDemo